<template>
  <div class="subscription-signup">
    <email-signup :is-submitting="isSubmitting" :message="message" :label-message="labelMessage" @email-submitted="onSubscriptionSubmitted" />
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
const EmailSignup = defineAsyncComponent(() => import("@/product/components/email-signup.vue"));
import FormsMixin from "@/mixins/forms.js";

export default {
  components: {
    EmailSignup,
  },

  mixins: [FormsMixin],

  props: {
    seller: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      email: "",
      isSubmitting: false,
      message: null,
    };
  },

  computed: {
    labelMessage() {
      return `Notify me when ${this.seller.name} releases a new product.`;
    },
  },

  methods: {
    onSubscriptionSubmitted(formData) {
      this.isSubmitting = true;

      formData.append("user_id", this.seller.id);

      this.submitFormWithoutMessage("/people/ajax/create-subscription", formData)
        .then((response) => {
          this.message = {
            text: response.data.message,
            type: "success",
          };
        })
        .catch(this.reportErrors)
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
<style>
.subscription-signup .Message--success {
  background-color: #fff;
}
</style>
